module.exports = __webpack_public_path__ + "static/media/aquaPark.0a8b2b7f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/aquaPark.JPG
// module id = 673
// module chunks = 0